import { MMButton as LibraryButton } from 'mmfintech-portal-commons'
import type { MMButtonProps } from 'mmfintech-portal-commons/types'

type ButtonVariant =
  | 'primary'
  | 'secondary'
  | 'alternative'
  | 'elevated'
  | 'tertiary'
  | 'clean'
  | 'menu-item'
  | 'square-elevated'
  | 'ads-square'
  | 'ads-square-alternative'

export const MMButton = (props: MMButtonProps<ButtonVariant>) => <LibraryButton {...props} />
